import config from '@/core/config/config';
import { Typography } from '@prenuvo/halo-web';
import { aboutPrenuvoLinks, exploreLinks, resourcesLinks } from './InformationLinks.constants';

const InformationLinks = () => {
  return (
    <div className="order-2 grid gap-6 sm:grid-cols-1 md:grid-cols-3 lg:order-none">
      <div>
        <Typography variant="label-xs" className="text-footerGray">
          Explore
        </Typography>
        <div className="mt-4">
          {exploreLinks.map((link) => (
            <Typography
              className="py-[0.6rem] text-geyser-500 transition ease-in-out hover:text-green-100"
              variant="paragraph-sm"
              key={link.label}
            >
              <a
                id={`footer-${link.label}`}
                aria-label={`click this link to go to ${link.label}`}
                href={`${config.BASE_URL}/${link.url}`}
              >
                {link.label}
              </a>
            </Typography>
          ))}
        </div>
      </div>
      <div>
        <Typography variant="label-xs" as="label" className="text-footerGray">
          Resources
        </Typography>
        <div className="mt-4">
          {resourcesLinks.map((link) => (
            <Typography
              className="py-[0.6rem] text-geyser-500 transition ease-in-out hover:text-green-100"
              variant="paragraph-sm"
              key={link.label}
            >
              <a
                id={`footer-${link.label}`}
                aria-label={`click this link to go to ${link.label}`}
                href={`${config.BASE_URL}/${link.url}`}
              >
                {link.label}
              </a>
            </Typography>
          ))}
        </div>
      </div>
      <div>
        <Typography variant="label-xs" as="label" className="mb-4 text-footerGray">
          About Prenuvo
        </Typography>
        <div className="mt-4">
          {aboutPrenuvoLinks.map((link) => (
            <Typography
              className="py-[0.6rem] text-geyser-500 transition ease-in-out hover:text-green-100"
              variant="paragraph-sm"
              key={link.label}
            >
              <a
                id={`footer-${link.label}`}
                aria-label={`click this link to go to ${link.label}`}
                href={`${config.BASE_URL}/${link.url}`}
              >
                {link.label}
              </a>
            </Typography>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InformationLinks;
